import React, {createContext, useContext} from 'react'

const InvertedSurfaceContext = createContext<boolean>(false)

/**
 * Signals that descendant content is rendered on the blue primary surface of the
 * legacy apps (e.g. HProduce `ThemeLightBlue`, where `--page_background` is blue but
 * `--foreground` stays dark). Shared feature components read {@link useInvertedSurface}
 * to pick the on-blue (inverted / white) foreground instead of the theme-aware dark one.
 *
 * Suite features render on the light page surface and must NOT provide this, so the
 * default `false` keeps the theme-aware foreground.
 */
export const InvertedSurfaceProvider: React.FC<{
  value?: boolean
  children: React.ReactNode
}> = ({value = true, children}) => (
  <InvertedSurfaceContext.Provider value={value}>{children}</InvertedSurfaceContext.Provider>
)

export const useInvertedSurface = (): boolean => useContext(InvertedSurfaceContext)
